import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, CanDeactivateGuard } from '../_guards';
import {
  RetentionOffersComponent,
  StageDetailsComponent,
  SegmentsComponent,
  SurveyStepsComponent,
  StageSettingsComponent,
  RetentionSettingsComponent,
  SingleStepPathComponent,
} from '.';
import { StepBuilderComponent, StepTemplatesComponent } from '../steps-library';
import { OfferBuilderSection } from '../steps-library/step-util';

// Shared child routes for "category/:offer_type"
const categoryChildRoutes = [
  {
    path: 'template/:step_type/:global',
    component: StepTemplatesComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'template/:step_type',
    component: StepTemplatesComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':step_type/step/:step_id',
    component: StepBuilderComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':step_type/step/:step_id/:confirmationStepType',
    component: StepBuilderComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':step_type/step/:step_id/:device',
    component: StepBuilderComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'step/:step_type',
    component: StepBuilderComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'step/:step_type/edit/:edit/template/:template_id',
    component: StepBuilderComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: 'step/:step_type/template/:template_id',
    component: StepBuilderComponent,
    canActivate: [AuthGuard],
    canDeactivate: [CanDeactivateGuard],
  },
];

const routes: Routes = [
  {
    path: 'retention',
    children: [
      {
        path: '',
        component: RetentionOffersComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':offer_id/intent/:offer_intent/settings',
        component: StageSettingsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'stage/:offer_id',
        children: [
          { path: '', component: StageDetailsComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
          { path: 'category/:offer_type', children: categoryChildRoutes },
          {
            path: 'segment',
            component: SegmentsComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
          },

          {
            path: 'segment/:segment_id',
            children: [
              {
                path: '',
                component: StageDetailsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
              },
              { path: 'category/:offer_type', children: categoryChildRoutes },
            ],
          },
        ],
      },
    ],
    data: { isAdminView: false, title: 'Retention', section: OfferBuilderSection.Retention },
  },
  {
    path: 'returns',
    children: [
      {
        path: '',
        component: RetentionOffersComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':offer_id/intent/:offer_intent/settings',
        component: StageSettingsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'stage/:offer_id',
        children: [
          { path: '', component: StageDetailsComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
          { path: 'category/:offer_type', children: categoryChildRoutes },
          {
            path: 'segment',
            component: SegmentsComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
          },

          {
            path: 'segment/:segment_id',
            children: [
              {
                path: '',
                component: StageDetailsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
              },
              { path: 'category/:offer_type', children: categoryChildRoutes },
            ],
          },
        ],
      },
    ],
    data: { isAdminView: false, title: 'Returns', section: OfferBuilderSection.Returns },
  },
  {
    path: 'resolve-paths',
    children: [
      {
        path: '',
        component: RetentionOffersComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':offer_id/intent/:offer_intent/settings',
        component: StageSettingsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'stage/:offer_id',
        children: [
          { path: '', component: StageDetailsComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
          { path: 'category/:offer_type', children: categoryChildRoutes },
          {
            path: 'segment',
            component: SegmentsComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
          },
          {
            path: 'segment/:segment_id',
            children: [
              {
                path: '',
                component: StageDetailsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard],
              },
              { path: 'category/:offer_type', children: categoryChildRoutes },
            ],
          },
        ],
      },
    ],
    data: { isAdminView: false, title: 'Resolve Paths', section: OfferBuilderSection.Resolve },
  },
  {
    path: 'admin/survey',
    data: { isAdminView: true, title: 'Admin Survey', section: OfferBuilderSection.Retention },
    children: [
      {
        path: '',
        component: SurveyStepsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'intent/:offer_intent/category/:offer_type/:step_type/step/:step_id',
        component: StepBuilderComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'intent/:offer_intent/category/:offer_type/step/:step_type',
        component: StepBuilderComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
  {
    path: 'survey',
    data: { isAdminView: false, title: 'Survey', section: OfferBuilderSection.Retention },
    children: [
      {
        path: '',
        component: SurveyStepsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'stage/:offer_id/category/:offer_type',
        children: categoryChildRoutes,
      },
    ],
  },
  {
    path: 'admin/retention',
    children: [
      {
        path: '',
        component: RetentionOffersComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'stage/:offer_id',
        children: [
          {
            path: '',
            component: StageDetailsComponent,
            canActivate: [AuthGuard],
            canDeactivate: [CanDeactivateGuard],
          },
          {
            path: 'category/:offer_type',
            children: categoryChildRoutes,
          },
        ],
      },
    ],
    data: { isAdminView: true, title: 'Admin Retention', section: OfferBuilderSection.Retention },
  },
  {
    path: 'single-step',
    data: { isAdminView: false, title: 'Single Step', section: OfferBuilderSection.Retention },
    children: [
      {
        path: '',
        component: SingleStepPathComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'stage/:offer_id/intent/:offer_intent/category/:offer_type',
        children: categoryChildRoutes,
      },
    ],
  },
  {
    path: 'retention-settings',
    data: { isAdminView: false, title: 'Retention Settings', section: OfferBuilderSection.Retention },
    children: [
      {
        path: '',
        component: RetentionSettingsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
  {
    path: 'returns-settings',
    data: { isAdminView: false, title: 'Returns Settings', section: OfferBuilderSection.Returns },
    children: [
      {
        path: '',
        component: RetentionSettingsComponent,
        canActivate: [AuthGuard],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class OfferBuilderRoutingModule {}
